module.exports = __webpack_public_path__ + "media/images/background_011-f941736431d00ac0f28ce691d9b17468.jpg";